import * as React from 'react';
import Avatar from '@mui/joy/Avatar';
import Box from '@mui/joy/Box';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import ListItemContent from '@mui/joy/ListItemContent';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import Typography from '@mui/joy/Typography';


import cardOne from '../../images/akashDev1.jpg';
import cardTwo from '../../images/asiff.jpg';
import cardThree from '../../images/nayem anime.jpeg';
import cardFour from '../../images/Anika apu.jpg';
import cardFive from '../../images/Asfaq.jpg';

export default function EllipsisList() {
  return (
    <Box sx={{ width: 320 }}>
      <Typography
        id="ellipsis-list-demo"
        level="body4"
        textTransform="uppercase"
        fontWeight="xl"
        mb={1}
        sx={{ letterSpacing: '0.15rem' }}
      >
        Team
      </Typography>
      <List
        aria-labelledby="ellipsis-list-demo"
        sx={{ '--List-decorator-size': '56px' }}
      >
        <ListItem>
          <ListItemDecorator sx={{ alignSelf: 'flex-start' }}>
            <Avatar src={cardOne} />
          </ListItemDecorator>
          <ListItemContent>
            <Typography>Shaikot Kundu Akash- WEB-APP Developer(Full-stack)</Typography>
            
          </ListItemContent>
        </ListItem>
        <ListItem>
          <ListItemDecorator sx={{ alignSelf: 'flex-start' }}>
            <Avatar src={cardTwo} />
          </ListItemDecorator>
          <ListItemContent>
            <Typography>Asiful Haque- Programmer & Idea Inovator</Typography>
            
          </ListItemContent>
        </ListItem>

        <ListItem>
          <ListItemDecorator sx={{ alignSelf: 'flex-start' }}>
            <Avatar src={cardThree} />
          </ListItemDecorator>
          <ListItemContent>
            <Typography>Md. Wahiduzzaman Nayem- Animator & Video Editor</Typography>
            
          </ListItemContent>
        </ListItem>

        <ListItem>
          <ListItemDecorator sx={{ alignSelf: 'flex-start' }}>
            <Avatar src={cardFour} />
          </ListItemDecorator>
          <ListItemContent>
            <Typography>Anika Tahshin- Presenter</Typography>
            
          </ListItemContent>
        </ListItem>

        <ListItem>
          <ListItemDecorator sx={{ alignSelf: 'flex-start' }}>
            <Avatar src={cardFive}/>
          </ListItemDecorator>
          <ListItemContent>
            <Typography>Asfaque Ahmed Meem- Team Manager</Typography>
            
          </ListItemContent>
        </ListItem>
      </List>
    </Box>
  );
}
